// Template resolver constants
export const FORECAST_ANOMALY_TEMPLATE = "Must have no anomalies in row count."
export const VOLUME_ANOMALY_DYNAMIC_TEMPLATE = "Must have a row count greater than the row count of the last run."
